export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";
export const API_CALL_SUCCESS = "API_CALL_SUCCESS";
